import { z } from 'zod';
import { pageableSchema } from '@/models/pageableSchema';
import { authorSchema } from './authorSchema';
import { referenceSchema } from './referenceSchema';

export const updateMapDataSchema = z.object({
  name: z.string(),
  width: z.number(),
  height: z.number(),
  defaultCenterX: z.number().optional().nullable(),
  defaultCenterY: z.number().optional().nullable(),
  defaultZoomLevel: z.number().optional().nullable(),
  notes: z.string(),
});

export const mapModelSchema = z.object({
  /** map id */
  id: z.number(),
  /** name of the map */
  name: z.string(),
  description: z.string(),
  /** map width */
  width: z.number(),
  /** map height */
  height: z.number(),
  /** default x center used in frontend visualization */
  defaultCenterX: z.number().nullable(),
  /** default y center used in frontend visualization */
  defaultCenterY: z.number().nullable(),
  /** default zoom level used in frontend visualization */
  defaultZoomLevel: z.number().nullable(),
  /** minimum zoom level available for the map */
  minZoom: z.number(),
  /** maximum zoom level available for the map */
  maxZoom: z.number(),
  authors: z.array(authorSchema),
  references: z.array(referenceSchema),
  creationDate: z.string().nullable(),
  modificationDates: z.array(z.string()),
});

export const mapModelsSchema = pageableSchema(mapModelSchema);
